<table #table [ngClass]="{ 'view-360': renderPSView }">
	<thead>
		<tr>
			<th
				class="text-align-{{ column.align }} text-14-bold"
				*ngFor="let column of columns; index as i"
				[ngClass]="{ sortable: sortable, sorted: sortedColumn === i }"
				(click)="sort($event, i); sortedColumn = i"
			>
				{{ column.label }}
				<ng-container *ngIf="sortable">
					<icon type="sort" *ngIf="sortedColumn !== i"></icon> <icon type="sort-asc" *ngIf="sortedColumn === i && isAscending"></icon>
					<icon type="sort-desc" *ngIf="sortedColumn === i && !isAscending"></icon>
				</ng-container>
				<!-- AVOID USING METHOD CALLS, PLS REVIEW AND REMOVE THIS COMMENT/REFACTOR -->
				<icon type="info-circle" *ngIf="column.infoBubbleKey" [matTooltip]="getContent(column.infoBubbleKey)" matTooltipPosition="right"></icon>
			</th>
		</tr>
	</thead>
	<tbody *ngIf="viewData">
		<tr *ngFor="let row of data; index as k">
			<td class="align-{{ column.align }} text-align-{{ column.align }}" [ngClass]="{ 'text-medium': i === 0 }" *ngFor="let column of columns; index as i">
				<ng-container *ngIf="viewData[k][i] || viewData[k][i] === 0; else notApplicable">
					<a
						*ngIf="column.name === 'description' && row.blackrockFund; else columnLabel"
						href="https://www.blackrock.com/us/financial-professionals/products/{{ row.portfolioId }}/"
						target="_blank"
						class="text-bold"
						>{{ viewData[k][i] }}
					</a>
					<ng-template #columnLabel> {{ viewData[k][i] }} </ng-template>
				</ng-container>
			</td>
		</tr>
	</tbody>
</table>
<ng-template #notApplicable> <i class="not-applicable">n/a</i> </ng-template>
